<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-showcase-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('components.showcase.create') }}</h4>
        </template>
        <template v-slot:body>
            <ShowcaseForm :showcase-prop="showcase" @change="onChangeShowcase"></ShowcaseForm>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewShowcase(showcase.title, showcase.description, showcase.state,
               showcase.privacy, showcase.password, showcase.price)">
                <i class="las la-check"></i>
                {{ $t('components.showcase.create') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    // TODO add check fields
    import {SHOWCASE_PRIVACY} from "../../common/constants";
    import {createShowcase} from "../../api";
    import ShowcaseForm from "../showcase/ShowcaseForm";
    import ModalContainer from "./ModalContainer";
    export default {
        name: "AddShowcaseModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                showcase: {
                    id: null,
                    title: "",
                    description: "",
                    password: "",
                    privacy: SHOWCASE_PRIVACY.ANYONE,

                },
                errorMessage: ""
            }
        },
        components: {ShowcaseForm, ModalContainer},
        methods: {
            async createNewShowcase(newShowcaseTitle, newShowcaseDescription, newShowcaseState, newShowcasePrivacy,
                                    newShowcasePassword, newShowcasePrice) {
                this.loading = true;
                try {
                    const resultShowcase = await createShowcase(newShowcaseTitle, newShowcaseDescription,
                        newShowcaseState, newShowcasePrivacy, newShowcasePassword, newShowcasePrice);
                    this.loading = false;
                    this.$emit('close-showcase-modal');
                    this.$nextTick(() => {
                        this.$router.push({ name: 'showcase_detail', params: { showcase_id: resultShowcase.id }});
                    });


                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onChangeShowcase(showcase) {
                this.showcase = showcase;
            }
        }
    };
</script>
